webpackJsonp([118606765383953],{

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(148);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(80);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _voucherAd = __webpack_require__(154);
	
	var _voucherAd2 = _interopRequireDefault(_voucherAd);
	
	var _siteConfig = __webpack_require__(65);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StagPage = function StagPage() {
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: _siteConfig2.default.siteName + ' | Stag & Hen Parties | ' + _siteConfig2.default.siteTitleAlt,
	      meta: [{
	        name: 'description',
	        content: 'Book your 4x4 experience day for Stag & Hen Parties or even ‘Stens’. Based in Cardiff South Wales with specially designed 4x4 off roading courses'
	      }]
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'stag-hen banner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'banner-info top-off-center text-center' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'uppercase' },
	          'Your one stop shop for ',
	          _react2.default.createElement('br', null),
	          'Stag & Hen parties'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button secondary uppercase large hide-for-small-only', href: '/bookings' },
	          'Bookings'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'small-12 medium-10 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-header' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'uppercase' },
	              'Stag & Hen party packages'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'large-9 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-body' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'subheader' },
	              'We specialise In giving your group a day to remember.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'If you are looking for a one stop shop for your party we can cater for all your needs.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Whether your looking for a whole day experience where you get to sample a variety of fun packed activities ...or your looking for that more trailer made approach we can accommodate your group.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'i',
	                null,
	                'We have a \u201Cstag goes free\u201D policy on groups of 10 or more.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Our team can provide:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                '4x4 experience days'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Clay pigeon shooting'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Mini bus hire'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Help sourcing hotels'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'All available from our 40 acre site which is easily within reach of the centre of Cardiff for your evening out.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'If you need advice on where to go in Cardiff or where to stay we\u2019re happy to advise best we can.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'aside',
	          { className: 'large-3 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-body' },
	            _react2.default.createElement(_voucherAd2.default, null)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = StagPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-stag-and-hen-parties-js-558812a9e1b06fb10e44.js